<template>
  <div class="checkout-success-page">
    <div class="container py-5 text-center">
      <div class="success-card mx-auto p-5 border">
        <div v-if="isVerifying" class="verifying-state">
          <div class="spinner-luxury"></div>
          <p class="mt-3 text-muted">Verifica pagamento in corso...</p>
        </div>

        <template v-else-if="isPaid">
          <div class="success-icon mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#28a745" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
          </div>
          <h1 class="page-title mb-3">PAGAMENTO CONFERMATO</h1>
          <p class="mb-4 text-muted">Il tuo pagamento è stato ricevuto con successo. Stiamo completando la registrazione dell'ordine...</p>
          <div class="verifying-state">
            <div class="spinner-luxury"></div>
          </div>
        </template>

        <template v-else-if="isConfirmed">
          <div class="success-icon mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#28a745" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
          </div>
          <h1 class="page-title mb-3">ORDINE RICEVUTO!</h1>
          <p class="mb-4 text-muted">Grazie per il tuo acquisto. Il tuo ordine è stato registrato con successo.</p>
          <div v-if="displayOrderNumber" class="order-info p-3 bg-light mb-4">
            <p class="mb-1 small text-uppercase fw-bold letter-spacing-1">{{ t('tracking.order_number') }}</p>
            <p class="h5 mb-0">#{{ displayOrderNumber }}</p>
          </div>
          <div class="actions d-flex flex-column gap-3">
            <button v-if="isGuest" @click="goToTracking" class="btn-black">TRACCIA IL TUO ORDINE</button>
            <button v-else @click="goToOrders" class="btn-black">VEDI I MIEI ORDINI</button>
            <button @click="goToHome" class="btn-outline">TORNA ALLA HOME</button>
          </div>
          <p class="mt-5 extra-small text-muted text-uppercase letter-spacing-1">
            Riceverai una mail di conferma a breve con tutti i dettagli.
          </p>
        </template>

        <template v-else-if="isProcessing">
          <div class="pending-icon mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#ffc107" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
          </div>
          <h1 class="page-title mb-3">VERIFICA IN CORSO</h1>
          <p class="mb-4 text-muted">Stiamo verificando il pagamento, potrebbe richiedere qualche istante...</p>
          <div class="verifying-state">
            <div class="spinner-luxury"></div>
          </div>
        </template>

        <template v-else-if="isPendingPayment">
          <div class="pending-icon mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#ffc107" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
          </div>
          <h1 class="page-title mb-3">PAGAMENTO IN ATTESA</h1>
          <p class="mb-4 text-muted">Stiamo elaborando il tuo pagamento (Klarna/PayPal). Riceverai un'email di conferma non appena sarà approvato.</p>
          <div class="actions d-flex flex-column gap-3">
            <button v-if="isGuest" @click="goToTracking" class="btn-black">TRACCIA IL TUO ORDINE</button>
            <button v-else @click="goToOrders" class="btn-black">VEDI I MIEI ORDINI</button>
            <button @click="goToHome" class="btn-outline">TORNA ALLA HOME</button>
          </div>
        </template>

        <template v-else-if="isPending">
          <div class="pending-icon mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#ffc107" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
          </div>
          <h1 class="page-title mb-3">PAGAMENTO IN ATTESA</h1>
          <p class="mb-2 text-muted">Hai annullato il pagamento o il processo non è stato completato.</p>
          <div v-if="displayOrderNumber" class="order-info p-3 bg-light mb-4">
            <p class="mb-1 small text-uppercase fw-bold letter-spacing-1">{{ t('tracking.order_number') }}</p>
            <p class="h5 mb-0">#{{ displayOrderNumber }}</p>
          </div>
          <div class="actions d-flex flex-column gap-3">
            <button @click="retryPayment" class="btn-black">TORNA AL CHECKOUT</button>
            <button @click="goToHome" class="btn-outline">TORNA ALLA HOME</button>
          </div>
        </template>

        <template v-else-if="isFailed">
          <div class="failed-icon mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#dc3545" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>
          </div>
          <h1 class="page-title mb-3">PAGAMENTO FALLITO</h1>
          <p class="mb-4 text-muted">Il pagamento non è andato a buon fine. Riprova o contatta l'assistenza.</p>
          <div v-if="displayOrderNumber" class="order-info p-3 bg-light mb-4">
            <p class="mb-1 small text-uppercase fw-bold letter-spacing-1">{{ t('tracking.order_number') }}</p>
            <p class="h5 mb-0">#{{ displayOrderNumber }}</p>
          </div>
          <div class="actions d-flex flex-column gap-3">
            <button @click="retryPayment" class="btn-black">RIPROVA PAGAMENTO</button>
            <button @click="goToHome" class="btn-outline">TORNA ALLA HOME</button>
          </div>
        </template>

        <template v-else-if="isTimeout">
          <div class="pending-icon mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#ffc107" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
          </div>
          <h1 class="page-title mb-3">CONFERMA IN CORSO</h1>
          <p class="mb-4 text-muted">Il tuo pagamento è stato ricevuto, stiamo completando la conferma dell'ordine. Riceverai a breve un'email di riepilogo.</p>
          <div class="actions d-flex flex-column gap-3">
            <button v-if="isGuest" @click="goToTracking" class="btn-black">TRACCIA IL TUO ORDINE</button>
            <button v-else @click="goToOrders" class="btn-black">VEDI I MIEI ORDINI</button>
            <button @click="goToHome" class="btn-outline">TORNA ALLA HOME</button>
          </div>
        </template>

        <template v-else-if="isUnderReview">
          <div class="pending-icon mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#ffc107" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
          </div>
          <h1 class="page-title mb-3">ORDINE IN VERIFICA</h1>
          <p class="mb-4 text-muted">Il pagamento è stato ricevuto, ma è in fase di verifica aggiuntiva. Ti aggiorneremo via email non appena l'ordine sarà confermato.</p>
          <div class="actions d-flex flex-column gap-3">
            <button v-if="isGuest" @click="goToTracking" class="btn-black">TRACCIA IL TUO ORDINE</button>
            <button v-else @click="goToOrders" class="btn-black">VEDI I MIEI ORDINI</button>
            <button @click="goToHome" class="btn-outline">TORNA ALLA HOME</button>
          </div>
        </template>

        <template v-else>
          <div class="error-icon mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#6c757d" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
          </div>
          <h1 class="page-title mb-3">STATO NON DISPONIBILE</h1>
          <p class="mb-4 text-muted">Non è stato possibile verificare lo stato del pagamento. Riprova o contatta l'assistenza.</p>
          <div class="actions d-flex flex-column gap-3">
            <button @click="goToHome" class="btn-outline">TORNA ALLA HOME</button>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/authStore'
import { useCart } from '@/composables/useCart'
import { useLanguage } from '@/composables/useLanguage'
import { salesOrderService } from '@/services/salesOrderService'
import { checkoutService } from '@/services/checkoutService'
import { cookieService } from '@/services/cookieService'

const route = useRoute()
const router = useRouter()
const authStore = useAuthStore()
const { clearCart } = useCart()
const { t } = useLanguage()

const orderId = ref(route.query.orderId)
const guestTrackingToken = ref(route.query.guestTrackingToken)
const sessionId = ref(route.query.session_id)

const isVerifying = ref(true)
const pageState = ref('verifying')
const orderDetail = ref(null)
let pollingTimer = null
let pollingAttempts = 0
const MAX_POLLING_ATTEMPTS = 10
const POLLING_INTERVAL = 2000

const isGuest = computed(() => !authStore.isAuthenticated && !!guestTrackingToken.value)

const isPaid = computed(() => pageState.value === 'paid')
const isConfirmed = computed(() => pageState.value === 'confirmed')
const isProcessing = computed(() => pageState.value === 'processing')
const isPendingPayment = computed(() => pageState.value === 'pendingpayment')
const isPending = computed(() => pageState.value === 'pending')
const isFailed = computed(() => pageState.value === 'failed')
const isTimeout = computed(() => pageState.value === 'timeout')
const isUnderReview = computed(() => pageState.value === 'underreview')

const displayOrderNumber = computed(() => orderDetail.value?.orderNumber || orderId.value)

const loadOrderDetails = async () => {
  try {
    if (isGuest.value && guestTrackingToken.value) {
      const data = await checkoutService.getGuestOrder(guestTrackingToken.value)
      orderDetail.value = data?.data || data
    } else if (orderId.value) {
      const data = await salesOrderService.getOrderDetails(orderId.value)
      orderDetail.value = data?.data || data
    }
  } catch (error) {
    console.error('[CheckoutSuccess] Error loading order details:', error)
  }
}

const startPolling = async () => {
  if (!orderId.value) {
    pageState.value = 'timeout'
    isVerifying.value = false
    return
  }

  pollingAttempts = 0
  const tryPoll = async () => {
    if (pollingAttempts >= MAX_POLLING_ATTEMPTS) {
      clearInterval(pollingTimer)
      pollingTimer = null
      if (pageState.value === 'paid') {
        pageState.value = 'timeout'
        isVerifying.value = false
      }
      return
    }

    try {
      const data = await checkoutService.getOrderStatus(orderId.value, sessionId.value || undefined, guestTrackingToken.value || undefined)
      const status = String(data?.status || '').toLowerCase()
      pollingAttempts++

      if (status === 'paid' || status === 'confirmed') {
        clearInterval(pollingTimer)
        pollingTimer = null
        await loadOrderDetails()
        pageState.value = 'confirmed'
        isVerifying.value = false
        sessionStorage.removeItem('checkout_form_data')
        
            // Meta Pixel: Purchase
            if (orderDetail.value && orderId.value) {
              const storageKey = `fb_purchase_tracked_${orderId.value}`
              if (!sessionStorage.getItem(storageKey)) {
                const items = orderDetail.value.items || []
                cookieService.trackPixelEvent('Purchase', {
                  value: orderDetail.value.totalAmount,
                  currency: 'EUR',
                  content_ids: items.map(item => String(item.categoryTypeSku || item.sku || item.productId || item.id)).filter(Boolean),
                  content_type: 'product',
                  num_items: items.reduce((acc, item) => acc + (item.quantity || 1), 0),
                  event_id: String(orderId.value) // For server-side deduplication
                })
                sessionStorage.setItem(storageKey, 'true')
              }
            }

            // TikTok Pixel: CompletePayment
            if (orderDetail.value && orderId.value) {
              const ttStorageKey = `tt_purchase_tracked_${orderId.value}`
              if (!sessionStorage.getItem(ttStorageKey)) {
                const items = orderDetail.value.items || []
                cookieService.trackTikTokEvent('CompletePayment', {
                  content_ids: items.map(item => String(item.categoryTypeSku || item.sku || item.productId || item.id)).filter(Boolean),
                  contents: items.map(item => ({
                    content_id: String(item.categoryTypeSku || item.sku || item.productId || item.id),
                    content_type: 'product',
                    content_name: item.productName || item.name,
                    price: item.unitPrice || item.price,
                    quantity: item.quantity
                  })).filter(item => item.content_id),
                  content_type: 'product',
                  value: orderDetail.value.totalAmount,
                  currency: 'EUR',
                  event_id: String(orderId.value)
                })
                sessionStorage.setItem(ttStorageKey, 'true')
              }
            }

            // Google: GA4 Purchase & Google Ads Conversion
            if (orderDetail.value && orderId.value) {
              const googleStorageKey = `google_purchase_tracked_${orderId.value}`
              if (!sessionStorage.getItem(googleStorageKey)) {
                const items = orderDetail.value.items || []
                
                // GA4 Purchase
                cookieService.trackGA4EcommerceEvent('purchase', {
                  transaction_id: String(orderId.value),
                  value: orderDetail.value.totalAmount,
                  currency: 'EUR',
                  items: items.map(item => ({
                    item_id: String(item.categoryTypeSku || item.sku || item.productId || item.id),
                    item_name: item.productName || item.name,
                    price: item.unitPrice || item.price,
                    quantity: item.quantity
                  })).filter(item => item.item_id)
                })

                // Google Ads Conversion (Handled via GTM)
                // cookieService.trackGoogleAdsConversion(String(orderId.value), orderDetail.value.totalAmount)

                sessionStorage.setItem(googleStorageKey, 'true')
              }
            }
        
        await clearCart()
      } else if (status === 'underreview') {
        clearInterval(pollingTimer)
        pollingTimer = null
        pageState.value = 'underreview'
        isVerifying.value = false
      } else if (status === 'pendingpayment') {
        clearInterval(pollingTimer)
        pollingTimer = null
        pageState.value = 'pendingpayment'
        isVerifying.value = false
      } else if (status === 'paymentfailed' || status === 'failed' || status === 'canceled' || status === 'cancelled') {
        clearInterval(pollingTimer)
        pollingTimer = null
        pageState.value = 'failed'
        isVerifying.value = false
      }
    } catch (error) {
      console.error('[CheckoutSuccess] Polling error:', error)
      pollingAttempts++
    }
  }

  await tryPoll()
  if (pageState.value === 'paid' || pageState.value === 'processing') {
    pollingTimer = setInterval(tryPoll, POLLING_INTERVAL)
  }
}

const rapidPollPendingPayment = async () => {
  const maxAttempts = 4
  const intervalMs = 1500

  for (let attempt = 0; attempt < maxAttempts; attempt++) {
    if (attempt > 0) {
      await new Promise(resolve => setTimeout(resolve, intervalMs))
    }

    try {
      const data = await checkoutService.getSessionStatus(sessionId.value)
      const paymentStatus = String(data?.paymentStatus || '').toLowerCase()
      const stripeStatus = String(data?.status || '').toLowerCase()

      if (paymentStatus === 'paid' || stripeStatus === 'complete') {
        pageState.value = 'paid'
        isVerifying.value = false
        await startPolling()
        return
      } else if (paymentStatus === 'processing' || stripeStatus === 'processing') {
        pageState.value = 'processing'
        isVerifying.value = false
        await startPolling()
        return
      } else if (paymentStatus === 'paymentfailed' || paymentStatus === 'failed' || stripeStatus === 'canceled') {
        pageState.value = 'failed'
        isVerifying.value = false
        return
      } else if (paymentStatus === 'pendingpayment' || stripeStatus === 'pendingpayment') {
        continue
      } else {
        continue
      }
    } catch (error) {
      console.error('[CheckoutSuccess] Rapid polling error:', error)
      continue
    }
  }

  pageState.value = 'pendingpayment'
  isVerifying.value = false
  await startPolling()
}

const verifySession = async () => {
  if (!sessionId.value) {
    isVerifying.value = false
    await startPolling()
    return
  }

  try {
    const data = await checkoutService.getSessionStatus(sessionId.value)
    const paymentStatus = String(data?.paymentStatus || '').toLowerCase()
    const stripeStatus = String(data?.status || '').toLowerCase()

    if (stripeStatus === 'open' || stripeStatus === 'canceled') {
      router.replace({ path: '/checkout', query: { payment_canceled: 'true' } })
      return
    }

    if (paymentStatus === 'paid' || stripeStatus === 'complete') {
      pageState.value = 'paid'
      isVerifying.value = false
      sessionStorage.removeItem('checkout_form_data')
      await startPolling()
    } else if (paymentStatus === 'pendingpayment' || stripeStatus === 'pendingpayment') {
      await rapidPollPendingPayment()
    } else if (paymentStatus === 'processing' || stripeStatus === 'processing') {
      pageState.value = 'processing'
      isVerifying.value = false
      await startPolling()
    } else if (paymentStatus === 'unpaid' || stripeStatus === 'expired' || stripeStatus === 'canceled') {
      pageState.value = 'pending'
      isVerifying.value = false
    } else {
      console.warn('[CheckoutSuccess] Unknown session status:', data)
      pageState.value = 'error'
      isVerifying.value = false
    }
  } catch (error) {
    console.error('[CheckoutSuccess] Error verifying session:', error)
    isVerifying.value = false
    await startPolling()
  }
}

const retryPayment = () => {
  router.push({ name: 'Checkout' })
}

const goToOrders = () => {
  router.push({ name: 'Account', query: { tab: 'orders' } })
}

const goToTracking = () => {
  if (guestTrackingToken.value) {
    router.push({ name: 'GuestTracking', params: { token: guestTrackingToken.value } })
  }
}

const goToHome = () => {
  router.push({ name: 'Home' })
}

onMounted(() => {
  verifySession()
})

onUnmounted(() => {
  if (pollingTimer) clearInterval(pollingTimer)
})
</script>

<style scoped>
.checkout-success-page {
  min-height: 80vh;
  display: flex;
  align-items: center;
  background: #fcfcfc;
}

.success-card {
  max-width: 500px;
  background: #fff;
}

.page-title {
  font-size: 20px;
  font-weight: 900;
  letter-spacing: 2px;
}

.btn-black {
  background: #000;
  color: #fff;
  border: none;
  padding: 15px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
}

.btn-outline {
  background: transparent;
  color: #000;
  border: 1px solid #000;
  padding: 15px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
}

.extra-small {
  font-size: 10px;
}

.letter-spacing-1 {
  letter-spacing: 1px;
}

.btn-tracking {
  background: #000;
  color: #fff;
  border: none;
  padding: 12px 20px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1px;
}

.btn-tracking-outline {
  background: transparent;
  color: #000;
  border: 1px solid #000;
  padding: 12px 20px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1px;
}

.spinner-luxury {
  width: 48px;
  height: 48px;
  border: 3px solid #e0e0e0;
  border-top-color: #000;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>
